import isEmpty from 'lodash/isEmpty';

import { TrackingPixelFiresOn } from '../enums/TrackingPixelFiresOn';
import { TrackingPixel } from '../types/TrackingPixel';

/**
 * Whether a page-view pixel fires for the keys of the page being viewed: it
 * does when its _Pages_ is empty (every page), or when any key ticked in
 * _Pages_ is among them.
 *
 * @example
 * // keys for /sign-up/pin-verify: ['sign-up/*', 'sign-up/pin-verify']
 * //
 * //   Pages ticked in Contentful     fires?
 * //   (none)                         yes, every page
 * //   ['sign-up/*']                  yes, the section
 * //   ['sign-up/pin-verify']         yes, the page
 * //   ['sign-up']                    no, that's the /sign-up page only
 */
export const isPixelForPage = (
  { firesOn, pages }: TrackingPixel,
  pageKeys: string[],
): boolean =>
  firesOn === TrackingPixelFiresOn.PAGE_VIEW &&
  (isEmpty(pages) || pages.some((page): boolean => pageKeys.includes(page)));
